import React, { useEffect } from "react";
import "./Program.css";
import ProgramCard from "../../Components/ProgramCard/ProgramCard";
import Loader from "../../Components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProgramsPage } from "../../Redux/Slices/AppSlices";

const Program = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { programsPage, loading } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getProgramsPage());
  }, []);

  if (loading) {
    return <Loader />;
  }

  const programs =
    programsPage?.programs?.map((item) => ({
      id: item.id,
      title: item.program,
      age: item.ageRange,
      images: item.images?.map((img) => img.url) || [],
      description:
        item.description?.map((block) =>
          block.children?.map((child) => child.text).join(""),
        ) || [],
      features: item.lists?.map((feature) => feature.item) || [],
      options: item.enrollmentOptions,
      teachers: item.teachersNo,
      children: item.childrenNo,
    })) || [];

  return (
    <div className="admission-page">
      <section className="Chooseus">
        <p className="founder-subtitle">{programsPage?.subTitle}</p>

        <h2 className="founder-title">
          {programsPage?.title?.split(" ").slice(0, -1).join(" ")}{" "}
          <span>{programsPage?.title?.split(" ").slice(-1)}</span>
        </h2>

        <div className="program-container">
          {programs.map((item, index) => (
            <div className="program-card-box-bg">
              <div className="landing-pages">
                <ProgramCard
                  item={item}
                  key={index}
                  reverse={index % 2 !== 0}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="landing-pages">
          <div className="program-table">
            <p className="founder-subtitle">{programsPage?.tableSubTitle}</p>

            <h2 className="founder-title">
              {programsPage?.tableTitle?.split(" ").slice(0, -1).join(" ")}{" "}
              <span>{programsPage?.tableTitle?.split(" ").slice(-1)}</span>
            </h2>
            <div className="program-table-box">
              <div className="table-scroll">
                {/* Table Header */}
                <div className="table-header">
                  <div>Program</div>
                  <div>Age Range</div>
                  <div>Enrollment Options</div>
                  <div>Number of Teachers</div>
                  <div>Number of Children</div>
                </div>

                {/* Table Rows */}
                {programs.map((item, index) => (
                  <div className="table-row" key={index}>
                    <div>{item.title}</div>
                    <div>{item.age} Years</div>
                    <div>{item.options}</div>
                    <div>{item.teachers}</div>
                    <div>{item.children}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Program;
